import { Avatar } from '@pepper/ui'

import s from './Assignee.module.css'

type Props = {
  assigneeData?: TeamMembers
}

export const Assignee = ({ assigneeData }: Props) => {
  return (
    <div className={s.container}>
      <div className={s.avatarContainer}>
        {assigneeData?.full_name && assigneeData?.avatar && (
          <Avatar src={assigneeData?.avatar} />
        )}
        {assigneeData?.full_name && !assigneeData?.avatar && (
          <Avatar className={s.avatar}>{assigneeData?.full_name[0]}</Avatar>
        )}
        <div className={s.assigneeNameRole}>
          <div className={s.assigneeName}>
            {assigneeData?.full_name ?? 'No user assigned'}
          </div>
          <div className={s.assigneeRole}>{assigneeData?.role ?? ''}</div>
        </div>
      </div>
    </div>
  )
}
